module.exports = __webpack_public_path__ + "img/logo-unc.fcff70a4.png";